import { Component, Input } from '@angular/core';

/**
 * Generated class for the PercentageListItemContentComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'percentage-list-item-content',
  templateUrl: 'percentage-list-item-content.html'
})
export class PercentageListItemContentComponent {

  @Input()
  fraction: number;
  @Input()
  caption: string;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/percentage-list-item-content/percentage-list-item-content.ts